import React from "react";
import logoImg from "../logo.png";

const Logo = ({ className = "h-12 w-auto" }) => (
  <button
    type="button"
    onClick={() => (window.location.href = "/")}
    className="flex items-center gap-3 text-white font-bold text-xl select-none focus:outline-none"
    aria-label="Nhamy Trang Chủ"
  >
    <div className="flex items-center gap-3">
      <img src={logoImg} alt="Nhamy.us" className="h-10 w-auto rounded-lg" />
    </div>
  </button>
);

export default Logo;
